import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [{ title: "menu_sidebar_management_user" }, { title: "menu_sidebar_management_user_partner_user" }];

const PartnerUserAdd = Loadable({
  loader: () => import("container/management/user/partnerUser"),
  loading() {
    return <Loader />;
  }
});

const PartnerUserUpdateRequest = Loadable({
  loader: () => import("container/management/user/partnerUser/updateRequest"),
  loading() {
    return <Loader />;
  }
});

const PartnerUserListListing = Loadable({
  loader: () => import("container/management/user/partnerUser/listing"),
  loading() {
    return <Loader />;
  }
});

export const partnerUserRoutes: IRoute[] = [
  {
    path: "/management/user/partner-user",
    element: <PartnerUserListListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/management/user/partner-user/details/:id?",
    element: <PartnerUserAdd />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "Users", link: "/management/user/partner-user?tableTab=Users" }]
    }
  },
  {
    path: "/management/user/partner-user/update-request/:id",
    element: <PartnerUserUpdateRequest />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "Requests", link: "/management/user/partner-user?tableTab=Requests" }]
    }
  }
];
